module.exports = __webpack_public_path__ + "static/media/processed.bb1f40c3.svg";